import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const useAuthStore = create(
    persist(
        (set, get) => ({
            token: null,
            refreshToken: null,
            isAuthenticated: false,
            user: null,

            setTokens: (token, refreshToken, user = null) => {
                set({
                    token,
                    refreshToken,
                    isAuthenticated: true,
                    user,
                });
            },

            setUser: (user) => {
                set({ user });
            },

            clearTokens: () => {
                set({
                    token: null,
                    refreshToken: null,
                    isAuthenticated: false,
                    user: null,
                });
            },

            updateToken: (newToken) => {
                set({ token: newToken });
            },

            refreshAccessToken: async () => {
                const { refreshToken } = get();

                if (!refreshToken) {
                    console.warn("No refresh token available");
                    return false;
                }

                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_AUTH}/refresh`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                refresh_token: refreshToken,
                            }),
                        }
                    );

                    if (response.ok) {
                        const data = await response.json();
                        const { access_token } = data;

                        // Actualizar tokens
                        get().setTokens(access_token, refreshToken, get().user);
                        return true;
                    } else {
                        console.error(
                            "Failed to refresh token:",
                            response.status
                        );
                        get().clearTokens();
                        return false;
                    }
                } catch (error) {
                    console.error("Error refreshing token:", error);
                    get().clearTokens();
                    return false;
                }
            },

            isTokenExpired: () => {
                const { token } = get();
                if (!token) return true;

                try {
                    // Decodificar JWT para verificar expiración
                    const payload = JSON.parse(atob(token.split(".")[1]));
                    const currentTime = Date.now() / 1000;
                    return payload.exp < currentTime;
                } catch (error) {
                    console.error("Error decoding token:", error);
                    return true;
                }
            },
        }),
        {
            name: "auth-storage",
            storage: createJSONStorage(() => sessionStorage),
            // Opcionalmente, puedes filtrar qué propiedades persistir
            partialize: (state) => ({
                token: state.token,
                refreshToken: state.refreshToken,
                isAuthenticated: state.isAuthenticated,
                user: state.user,
            }),
        }
    )
);

export { useAuthStore };
